import { Link, NavLink, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import ThemeToggle from './ThemeToggle'

export default function Header() {
  const { user, signOut } = useAuth()
  const location = useLocation()

  const handleLogout = () => {
    signOut()
  }

  const isActive = (to: string) => location.pathname.startsWith(to)

  return (
    <header className="glass-header">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 no-underline">
            <div className="w-8 h-8 rounded-lg bg-brand-primary flex items-center justify-center text-white font-bold shadow-md">
              c
            </div>
            <span className="text-lg font-bold gradient-text">certi</span>
          </Link>

          <nav className="hidden md:flex items-center gap-2">
            <NavLink to="/marketplace" className={({isActive: navIsActive}) => `nav-pill ${navIsActive || isActive('/marketplace') ? 'active' : ''}`}>
              Marketplace
            </NavLink>
            <NavLink to="/dashboard" className={({isActive: navIsActive}) => `nav-pill ${navIsActive || isActive('/dashboard') ? 'active' : ''}`}>
              Dashboard
            </NavLink>
            <NavLink to="/profile" className={({isActive: navIsActive}) => `nav-pill ${navIsActive || isActive('/profile') ? 'active' : ''}`}>
              Profile
            </NavLink>
          </nav>

          <div className="flex items-center gap-2">
            <ThemeToggle />
            {user && (
              <div className="hidden sm:flex items-center gap-2 px-2 py-1 rounded-full border" style={{ borderColor: 'var(--border-primary)', background: 'var(--surface-secondary)' }}>
                <div className="w-6 h-6 rounded-full bg-brand-primary text-white flex items-center justify-center text-xs">
                  {user.firstName?.[0]?.toUpperCase() || 'U'}
                </div>
                <span className="text-sm" style={{ color: 'var(--text-secondary)' }}>{user.firstName}</span>
              </div>
            )}
            <button onClick={handleLogout} className="nav-pill">
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}
